import React from 'react';
import LegalPage from './index';
import { LEGAL_TYPES } from '../../components/modules/LegalPage/LegalContent/LegalTypes';

const TermsOfServicePage = () => <LegalPage type={LEGAL_TYPES.PRIVACY_POLICY} />;

export default TermsOfServicePage;